<template>
  <div class="about">
    <v-card class="pa-3">
    <h3>営業時間のご案内</h3>

        <div v-for="i of 30" class="bizHoursDiv" :key="i">
          <v-layout row wrap >
          <v-flex xs12 class="bgflex text-xs-center">
            {{bizHourCalendarText(i)}}
            {{bizHourYmdLocalText(i)}}
          </v-flex>
          </v-layout>

          <v-layout row wrap v-if="getHolidayDesc(i)">
            <v-flex xs12 class="bgflex text-xs-center">
            {{getHolidayDesc(i)}}
            </v-flex>
          </v-layout>

          <template v-for="serviceName in services" >
            <v-layout row wrap :key="i+serviceName">
              <v-flex xs4 class="bgflex pl-1">{{businessHoursVues[serviceName]["titleJa"]}}</v-flex>

                <v-flex xs8  class="text-xs-center" v-if="businessHoursVues[serviceName].days[i-1]">
                  <div v-if="isDayLengthTrue(serviceName,i)">
                    <template v-for="(range,rangeIndex) in businessHoursVues[serviceName].days[i-1].ranges" >
                      <span :key="rangeIndex">
                        {{range}}<br/>
                      </span>
                    </template>

                  </div>

                  <span class="red--text" v-if="isClosed(serviceName,i)">お休み</span>
                </v-flex>

            </v-layout>
          </template>

        </div>





    </v-card>
  </div>
</template>
<script>
import  { Logger } from 'aws-amplify';
const logger = new Logger('Cart','INFO');
import { AmplifyEventBus } from 'aws-amplify-vue'
import moment from 'moment-timezone'

export default {
  data () {
    return {
      businessHoursVues: undefined,
      menu:undefined,
      lang:undefined,
    }
  },
  created() {
  },
  beforeDestroy() {
    AmplifyEventBus.$emit('setBizHours', true)
  },
  mounted() {
    AmplifyEventBus.$emit('setBackTo', "/")
    AmplifyEventBus.$emit('setBizHours', false)
    AmplifyEventBus.$emit('setJourney', {key:"page",value:"営業時間のご案内"} )
    this.businessHoursVues = this.$store.getters.businessHours(moment())
    logger.info("businessHoursVues",this.businessHoursVues)
    this.menu = this.$store.state.menu
    this.lang = this.menu.defalutSettings.defaultLang

  },
  methods: {
    isDayLengthTrue:function(serviceName,i){
      if(this.businessHoursVues[serviceName]
              && this.businessHoursVues[serviceName].days[i-1]
              && this.businessHoursVues[serviceName].days[i-1].ranges
              && this.businessHoursVues[serviceName].days[i-1].ranges.length>0){
        return true
      }else{
        return false
      }

    },
    bizHourCalendarText: function (i) {
      //logger.info("bizHourCalendarText",i)
      const num = i - 1
      let res = ""
      if (this.businessHoursVues
              && this.businessHoursVues.dayTextLang
              && this.businessHoursVues.dayTextLang[num]
      ) {
        res += this.businessHoursVues.dayTextLang[num].calendar[this.lang]
      }
      return res
    },
    bizHourYmdLocalText: function (i) {
      const num = i - 1
      let res = ""
      if (this.businessHoursVues
              && this.businessHoursVues.dayTextLang
              && this.businessHoursVues.dayTextLang[num]
      ) {
        res += this.businessHoursVues.dayTextLang[num].ymdLocal[this.lang]
      }
      return res
    },
    getHolidayDesc:function(dayNum){
      let res=""
      const num = dayNum - 1
      const lang = this.lang

      if (this.businessHoursVues
              && this.businessHoursVues.dayTextLang
              && this.businessHoursVues.dayTextLang[num]
      ) {
        const targetDay = this.businessHoursVues.dayTextLang[num].ymd
        //logger.info("targetDay",targetDay)
        for(let i in this.menu.businessHours.holidays){
          const holidayObjKey = this.menu.businessHours.holidays[i]
          const holidayObj = this.menu.businessHours.HolidayDetail[holidayObjKey]
          for(let day in holidayObj){
            if(day==targetDay){
              if(holidayObj[day][lang]){
                res += holidayObj[day][lang]
              }else{
                const keys = Object.keys(holidayObj[day])
                res += holidayObj[day][keys[0]]
              }
            }
          }
        }
      }
      return res
    },
    isClosed:function(serviceName,i){
      if(!this.businessHoursVues[serviceName].days[i-1].ranges){
        return true
      }else{
        if(this.businessHoursVues[serviceName]
                && this.businessHoursVues[serviceName].days[i-1]
                && this.businessHoursVues[serviceName].days[i-1].ranges
                && this.businessHoursVues[serviceName].days[i-1].ranges.length>0){
          return false
        }else{
          return true
        }
      }

    }
  },
  computed:{
    services:function(){
      if(this.menu && this.menu.defalutSettings){
        return this.menu.defalutSettings.serviceProvided
      }else{
        return []
      }

    },

  }
}
</script>

<style>
  .bizHoursDiv{
    background-color: white;
    border-radius: 12px;
    padding:20px;

  }

  .bizHoursDiv .flex{
    color:#858585;
    border:1px solid #d3c6bf;
  }

  .bizHoursDiv .bgflex{
    background-color: #ece6e3;
  }
</style>